import type { Resource } from '../../';
export const country_countries_TW: Resource = {"default":"Taiwan"};
